import {
  AttachmentFragment,
  CollaborationV1AttachmentInput,
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables,
  useCreateAttachmentMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';

export const useCreateAttachment = withStandardCreateHook<
  CreateAttachmentMutation,
  AttachmentFragment,
  'createAttachment',
  CreateAttachmentMutationVariables,
  [CollaborationV1AttachmentInput]
>(
  useCreateAttachmentMutation,
  'createAttachment',
  input => ({
    attachment: input,
  }),
  {
    refetchQueries: ['Attachments'],
    awaitRefetchQueries: true,
  },
);
